import clsx from "clsx";
import { forwardRef, type HTMLAttributes } from "react";

import styles from "./body.module.css";

type Props = HTMLAttributes<HTMLDivElement>;

const Body = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { className, ...otherProps } = props;

    return <div {...otherProps} ref={ref} className={clsx(styles.body, className)} />;
});

Body.displayName = "Dialog.Content.Body";

export { Body as DialogContentBody };
export type { Props as DialogContentBodyProps };
